import './channels.scss';
import {environment} from '../../environments/evironment';
import './channels.functions';
import channelWindow  from '../content-window/content-window';
import common from '../../helpers/common';

export default {
    /**
     * reder channels and iframes
     * @param {*} accountSettings 
     * @returns 
     */
    createChannels(accountSettings){
    var channels = common.sortJSON(accountSettings.ChannelsByAccount,"IconOrder","asc");

    channels = channels.filter(function(item) {
        return item.Status && item.Status === 1;
    });
    
    var channelLength = channels.length;
    var btnSize = '';
    var channelHTML = '';
    var windowHTML = '';
    var channelClass = '';

    if(channelLength == 1){
        channelClass = `dgButton ${accountSettings["Style"].Size.CodeName}`;
    } else {
        channelClass = "dg-channel";
    }

    var _this = this;

    channels.forEach(function (channel) {
        if(channel["Channel"].ChannelName != "Click to Call"){

            var channelDto = {
                "Id": channel.Id,
                "Channel": channel.Channel,
                "LoadAction": channel.LoadAction,
                "MainUrl": channel.MainUrl,
                "SecondaryUrl": channel.SecondaryUrl,
                "entryPointPerChannelByAccounts": channel.entryPointPerChannelByAccounts
            };

            var channelString = btoa(JSON.stringify(channelDto));

            if(channel.CustomImage == 1){
                channelClass = "dg-single-channel customeImg";
                btnSize = "customeImg";
                _this.setImgSize(environment.BLOB_URL + channel.IconName);
            } else {
                btnSize = "dg-btn-" + accountSettings["Style"]["Size"].CodeName;
            }

            var channelSubtitle = "";
            if(channel.Subtitle){
                channelSubtitle = `<span class="item-subTitle">${channel.Subtitle}</span>`;
            }
            channelHTML += `
                <a class="${channelClass}" data-channel="${channelString}">
                    ${channelSubtitle}
                    <img src="${environment.BLOB_URL + channel.IconName}" />
                </a>
            `;

            windowHTML += channelWindow.setWindow(channel, btnSize);
        }
    });

    return {
        "channelHTML": channelHTML,
        "windowHTML": windowHTML
    };
},
    /**
     * set custome image size global
     * @param {*} imgUrl 
     */
    setImgSize(imgUrl){
        var img = new Image();
        img.src = imgUrl;
        img.onload = function() {
            window.DGcustomeImg = this.width;
        }
    }
};